import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/lisapay-proceed";

export default {
    setRegistered(id) {
        return Repository.put(`${resource}/${id}/set-registered`);
    },
    postCollectRetry(id) {
        return Repository.post(`${resource}/${id}/post-collect-retry`);
    },
    create(payload) {
        return Repository.post(`${resource}`, payload);
    },
    index(queryString) {
        // get the list
        return queryString
            ? Repository.get(`${resource}?${queryString}`)
            : Repository.get(`${resource}`);
    },
    collectedAmount(queryString) {
        return queryString
            ? Repository.get(`${resource}/collected-amount?${queryString}`)
            : Repository.get(`${resource}/collected-amount`);
    },
};